import React, { useState } from "react";
import { Mail, Check } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL || "";

/** Email capture for the weekly article digest. compact=true for in-app use. */
export const BlogSubscribeBox = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | done | error

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setState("sending");
    try {
      const r = await fetch(`${API}/api/blog/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      setState(r.ok ? "done" : "error");
    } catch {
      setState("error");
    }
  };

  if (state === "done") {
    return (
      <div
        className={`rounded-2xl border border-[#39FF14]/30 bg-[#39FF14]/[0.06] ${compact ? "p-4" : "p-6"} text-center`}
        data-testid="blog-subscribe-done"
      >
        <Check className="w-5 h-5 mx-auto text-[#39FF14]" />
        <div className={`mt-2 text-white font-medium ${compact ? "text-[13px]" : "text-sm"}`}>
          You're in — new articles land in your inbox every week.
        </div>
      </div>
    );
  }

  return (
    <div
      className={`rounded-2xl border border-white/10 bg-white/[0.02] ${compact ? "p-4" : "p-6"}`}
      data-testid="blog-subscribe-box"
    >
      <div className={`flex items-center gap-2 text-white font-semibold ${compact ? "text-[13px]" : "text-sm"}`}>
        <Mail className="w-4 h-4 text-[#39FF14]" /> Get new articles weekly
      </div>
      <p className={`mt-1 text-zinc-500 ${compact ? "text-[11px]" : "text-xs"}`}>
        One email a week with the latest owner guides. No spam, unsubscribe in one click.
      </p>
      <form onSubmit={submit} className="mt-3 flex gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          data-testid="blog-subscribe-input"
          className={`flex-1 min-w-0 rounded-lg border border-white/10 bg-black/40 px-3 ${compact ? "py-2 text-[12px]" : "py-2.5 text-sm"} text-white placeholder:text-zinc-600 focus:outline-none focus:border-[#39FF14]/50 transition-colors`}
        />
        <button
          type="submit"
          disabled={state === "sending"}
          data-testid="blog-subscribe-submit"
          className={`shrink-0 brand-gradient text-black font-semibold rounded-lg px-4 ${compact ? "text-[11px]" : "text-xs"} uppercase tracking-wider hover:opacity-90 transition-opacity disabled:opacity-50`}
        >
          {state === "sending" ? "…" : "Subscribe"}
        </button>
      </form>
      {state === "error" && (
        <div className="mt-2 text-[11px] text-red-400" data-testid="blog-subscribe-error">
          Something went wrong — please try again.
        </div>
      )}
    </div>
  );
};

export default BlogSubscribeBox;
